export const UNIT_COOKIE = 'outdoorish_unit'

export const LOGGED_IN_COOKIE = 'bikemap_logged_in'
